import React from 'react';
import Img from 'gatsby-image';
import { media, TransitionMixin } from '../components/helpers';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import styled from 'styled-components';
import { HomeBanner } from '../components/Banners';
import { HomeSlider } from '../components/Sliders';
import Link from 'gatsby-link';
import MetaTags from '../components/MetaTags';

const AboutSection = styled.section`
	background: #232323;
	display: grid;
	${media.large`grid-template-columns: 50% 50%;`};

	.content-section {
		align-self: center;
		padding: 40px 20px 0px;
		order: 2;
		${media.medium`padding: 70px 50px;`};
		${media.large`padding: 50px; order: 1;`};
	}

	.img-section {
		order: 1;
		${media.large`order: 2;`};
	}
	.title-wrap {
		text-align: left;
		${media.small`text-align: center;`};
		h2 {
			color: #fff;
			font-family: 'Roboto', sans-serif;
			margin: 0px;
			font-weight: 300;
			font-size: 30px;
			${media.xl`font-size: 40px;`};
		}
	}

	.about--footer {
		text-align: center;
		padding: 40px 0px;

		a {
			color: #fff;
			text-decoration: none;
			border: 1px solid #fff;
			padding: 10px 0px;
			width: 200px;
			display: block;
			margin: 0;
			border-radius: 0px;
			text-transform: uppercase;
			font-size: 12px;
			letter-spacing: 1px;

			${media.medium`margin: 0 auto;`};
			&:hover {
				background: #fff;
				color: #222;
			}
		}
	}

	.inner-wrap {
		max-width: 750px;
		margin: 0 auto;
		text-align: center;
	}

	p {
		color: #fff;
		font-family: 'Roboto', sans-serif;
		font-weight: 200;
		line-height: 30px;
		font-size: 16px;
		text-align: left;
		margin-bottom: 0px;
		${media.medium`text-align:center; line-height: 40px;`};
		${media.xl`font-size: 18px;`};
	}
`;

const ServiceSection = styled.section`
	padding: 50px 0px 0px;
	background: #222;
	border-bottom: 1px solid #efefef;
	${media.xl`padding: 70px 0px 0px;`};
	.title-wrap {
		text-align: center;

		h2 {
			color: #fff;
			font-size: 30px;
			font-family: 'Roboto', sans-serif;
			font-weight: 300;
			margin-top: 0px;
			margin-bottom: 45px;
		}
	}

	.services-wrap {
		.wrap {
			max-width: 100vw;
			margin: 0 auto;
			display: grid;

			${media.large`grid-template-columns: 1fr 1fr 1fr;`};
		}
		.service {
			position: relative;
			overflow: hidden;
			.inner-wrap {
				text-align: center;
				.image-wrap {
					.overlay {
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;

						&.pink {
							background: rgba(243, 23, 221, 0.8);
						}

						&.blue {
							background: rgba(0, 156, 255, 0.8);
						}

						&.green {
							background: rgba(3, 206, 4, 0.8);
						}
					}
				}

				.overlay-wrap {
					position: absolute;
					top: 80%;
					text-align: left;
					padding: 0px 20px;
					${TransitionMixin('.25s')};

					p {
						color: #fff;
					}
				}

				h3 {
					color: #fff;
					font-family: 'Roboto', sans-serif;
					font-size: 30px;
					span {
						font-size: 14px;
						display: block;
						margin-top: 10px;
						line-height: 23px;
					}
				}
			}

			a {
				color: #fff;
				text-decoration: none;

				&:hover {
					.overlay-wrap {
						top: 20%;
					}
				}
			}
		}
	}
`;

const WorkPreviewSlider = styled.div`
	background: #232323;
	.title-wrap {
		text-align: center;
		padding: 20px 0px;
		border-top: 1px solid #efefef;
		border-bottom: 1px solid #efefef;

		h2 {
			color: #fff;
			margin: 0px;
			font-family: 'Roboto', sans-serif;
			font-weight: 300;
		}
	}

	.slick-current {
		z-index: 10000;
	}

	.slick-dots {
		bottom: 20px;
	}
	.slick-dots li button:before {
		font-size: 18px;
		color: transparent;
		border: 1px solid #fff;
		border-radius: 20px;
		${TransitionMixin('.25s')};
	}

	.slick-dots li.slick-active button:before {
		opacity: 0.75;
		color: #fff;
	}

	.slick-dots li button:before {
		line-height: 23px;
	}

	.slick-dots li button {
		font-size: 0;
		line-height: 0;
		display: block;
		width: 20px;
		height: 20px;
		padding: 5px;
		cursor: pointer;
		color: transparent;
		border: 0;
		outline: none;
		background: transparent;
	}
`;

export default class IndexPage extends React.Component {
	render() {
		const { data } = this.props;
		return (
			<div className="page-wrap">
				<MetaTags
					title="Wavey Media Group | Digital Brand Strategists"
					description="We map the exhibition of brands before they need to
				take the next step."
					source_url={data.metaImage.absolutePath}
				/>
				<HomeBanner>
					<Img sizes={data.topBanner.sizes} className="desktop banner" />
					<Img
						sizes={data.mobileTopBanner.sizes}
						style={{ height: '70vh' }}
						imgStyle={{ height: '70vh' }}
						className="mobile banner"
					/>

					<div className="banner-content">
						<div className="inner-wrap">
							<h1>
								Simple. Clean. Original.
								<span>We create stunning web experiences</span>
							</h1>
						</div>
					</div>
					<div className="bottom-wrap">
						<div className="arrow-wrap">
							<AnchorLink offset="70" href="#AboutSection">
								<Img sizes={data.arrow.sizes} />
							</AnchorLink>
						</div>
					</div>
					<div className="overlay" />
				</HomeBanner>
				{/* <ServiceSection id="ServiceSection">
					<div className="title-wrap">
						<h2>Our Services</h2>
					</div>

					
				</ServiceSection> */}
				<AboutSection id="AboutSection">
					<div className="content-section">
						<div className="title-wrap">
							<h2>Wild predictions for the future are everywhere.</h2>
						</div>

						<div className="inner-wrap">
							<p>
								Soon, people will look at smart phones with the same eyeroll
								they give cassette players, and central assets, like websites,
								will be beyond just dynamic, but utterly and wholly
								experiential. That's why we're a new type of agency. We map the
								exhibition of brands before they need to take the next step.
								Because the nature of change, is in fact changing. And change is
								rapidly happening with all sorts of things.
							</p>
							<div className="about--footer">
								<Link to="/about" className="btn-outline">
									Learn More
								</Link>
							</div>
						</div>
					</div>

					<div className="img-section">
						<Img sizes={data.aboutBanner.sizes} />
					</div>
				</AboutSection>
				<WorkPreviewSlider>
					<div className="title-wrap">
						<h2>Recent Work</h2>
					</div>
					<HomeSlider slides={data.allWordpressWpPortfolio.edges} />
				</WorkPreviewSlider>
			</div>
		);
	}
}

export const query = graphql`
	query homeData {
		topBanner: imageSharp(id: { regex: "/sf.jpeg/" }) {
			sizes(quality: 100, maxWidth: 2300) {
				...GatsbyImageSharpSizes
			}
		}
		metaImage: file(id: { regex: "/sf.jpeg/" }) {
			absolutePath
		}
		mobileTopBanner: imageSharp(id: { regex: "/mhome.jpeg/" }) {
			sizes(quality: 100, maxWidth: 1200) {
				...GatsbyImageSharpSizes
			}
		}
		aboutBanner: imageSharp(id: { regex: "/startup.jpg/" }) {
			sizes(quality: 100, maxWidth: 1200) {
				...GatsbyImageSharpSizes
			}
		}

		design: imageSharp(id: { regex: "/design.jpeg/" }) {
			sizes(quality: 100, maxWidth: 1200) {
				...GatsbyImageSharpSizes
			}
		}

		dev: imageSharp(id: { regex: "/dev.png/" }) {
			sizes(quality: 100, maxWidth: 1200) {
				...GatsbyImageSharpSizes
			}
		}

		branding: imageSharp(id: { regex: "/branding.jpg/" }) {
			sizes(quality: 100, maxWidth: 1200) {
				...GatsbyImageSharpSizes
			}
		}

		arrow: imageSharp(id: { regex: "/white-arrow.png/" }) {
			sizes(quality: 100, maxWidth: 100) {
				...GatsbyImageSharpSizes
			}
		}
		allWordpressWpPortfolio {
			edges {
				node {
					id
					title
					categories {
						name
					}
					acf {
						site_url
						client
						date_completed
						tags
						brand_caption
					}
					featured_media {
						source_url
						localFile {
							childImageSharp {
								sizes(quality: 100, maxWidth: 2100) {
									...GatsbyImageSharpSizes
								}
							}
						}
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/index.js